import React from 'react';
import { useRouter } from '../../components';

export function NoPermission({ 
  title = "Access Denied", 
  message = "You don't have permission to access this page.",
  showGoBack = true,
  customActions = null 
}) {
  const router = useRouter();

  const handleGoBack = () => {
    // Simply go back in browser history
    // If there's no history, the button won't do anything and user can use "Go to Home"
    window.history.back();
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '400px',
      padding: '2rem',
      textAlign: 'center',
      maxWidth: '600px',
      margin: '0 auto'
    }}>
      {/* Warning Icon */}
      <div style={{
        width: '80px',
        height: '80px',
        borderRadius: '50%',
        backgroundColor: '#ffeaa7',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '1.5rem',
        border: '3px solid #fdcb6e'
      }}>
        <svg 
          width="40" 
          height="40" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="#e17055" 
          strokeWidth="2"
        >
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
          <line x1="12" y1="9" x2="12" y2="13"/>
          <line x1="12" y1="17" x2="12.01" y2="17"/>
        </svg>
      </div>

      {/* Title */}
      <h1 style={{
        fontSize: '1.75rem',
        fontWeight: '600',
        color: '#2d3436',
        marginBottom: '0.5rem',
        margin: 0
      }}>
        {title}
      </h1>

      {/* Message */}
      <p style={{
        fontSize: '1rem',
        color: '#636e72',
        marginBottom: '2rem',
        lineHeight: '1.5'
      }}>
        {message}
      </p>

      {/* Actions */}
      <div style={{
        display: 'flex',
        gap: '1rem',
        flexWrap: 'wrap',
        justifyContent: 'center'
      }}>
        {showGoBack && (
          <button
            onClick={handleGoBack}
            style={{
              padding: '0.75rem 1.5rem',
              backgroundColor: '#74b9ff',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '0.9rem',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#0984e3';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = '#74b9ff';
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M19 12H5"/>
              <path d="M12 19l-7-7 7-7"/>
            </svg>
            Go Back
          </button>
        )}

        <button
          onClick={() => router.push('/')}
          style={{
            padding: '0.75rem 1.5rem',
            backgroundColor: 'transparent',
            color: '#636e72',
            border: '1px solid #ddd',
            borderRadius: '6px',
            fontSize: '0.9rem',
            fontWeight: '500',
            cursor: 'pointer',
            transition: 'all 0.2s ease'
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = '#f8f9fa';
            e.target.style.borderColor = '#adb5bd';
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = 'transparent';
            e.target.style.borderColor = '#ddd';
          }}
        >
          Go to Home
        </button>

        {customActions}
      </div>

      {/* Additional Help */}
      <div style={{
        marginTop: '2rem',
        padding: '1rem',
        backgroundColor: '#f8f9fa',
        borderRadius: '6px',
        border: '1px solid #e9ecef',
        fontSize: '0.85rem',
        color: '#6c757d'
      }}>
        <strong>Need access?</strong> Contact your National Secretaries or check if you have the correct membership level.
      </div>
    </div>
  );
} 